/**
 * Shared renderer for AI-generated prose across Atlas — Trace's decoupling
 * suggestions, Impact's mitigation ideas, Compliance's narrative, Refactor's
 * PR draft, Sandbox's AI proposal preview, and the Ask Atlas chat. Every one
 * of these previously printed raw markdown (**bold**, `code`, "1. ") as
 * literal text; this is the one place that stops happening.
 *
 * react-markdown parses to real React elements (no dangerouslySetInnerHTML),
 * so AI-service text can never inject raw HTML/script into the page.
 */
import ReactMarkdown from 'react-markdown';

export interface AiMarkdownProps {
  text: string;
  className?: string;
}

export function AiMarkdown({ text, className }: AiMarkdownProps): React.JSX.Element {
  return (
    <div className={className ? `ai-md ${className}` : 'ai-md'}>
      <ReactMarkdown>{text}</ReactMarkdown>
    </div>
  );
}
